import { createSlice } from '@reduxjs/toolkit';
import { downloadVideos } from './azimut-for-you-thunks';
import { AzimutForYouState } from './azimut-for-you-types';

const initialState: AzimutForYouState = {
  videos: undefined,
  videosRequestStatus: 'idle',
  videosError: undefined,
};

const azimutForYou = createSlice({
  name: 'features/documents/offering',
  initialState: initialState,
  reducers: {
    clearError(state) {
      state.videosError = undefined;
      state.videosRequestStatus = 'idle';
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(downloadVideos.pending, (state) => {
      state.videosRequestStatus = 'loading';
    });
    builder.addCase(downloadVideos.fulfilled, (state, action) => {
      state.videosRequestStatus = 'succeeded';
      state.videosError = undefined;
      state.videos = action.payload;
    });
    builder.addCase(downloadVideos.rejected, (state, action) => {
      state.videosError = action.payload || 'GENERIC_ERROR';
      state.videosRequestStatus = 'failed';
    });
  },
});

export const azimutForYouActions = azimutForYou.actions;

export default azimutForYou.reducer;
